var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as contentDisposition from "content-disposition";
import * as download from "downloadjs";
import * as React from 'react';
import { Line } from "react-chartjs-2";
import { Button, Checkbox, Dimmer, Dropdown, Form, Grid, Header, Icon, Input, Loader, Menu, Message, Popup } from "semantic-ui-react";
import { Help } from "../Help";
import { getWithAuthn, postJsonWithAuthn } from "../RequestHelpers";
import { dateOnlyFormat } from "./AllOrdersPage";
import DateRangePicker from "./DateRangePicker";
var ReportsPage = /** @class */ (function (_super) {
    __extends(ReportsPage, _super);
    function ReportsPage(props) {
        var _this = _super.call(this, props) || this;
        _this.renderReportTypePicker = function (config, availableReports) {
            return React.createElement(React.Fragment, null,
                React.createElement(Grid, { columns: 3, celled: 'internally' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement("h5", null, "General reports"),
                            _this.getReportCategory(availableReports, "GENERAL")),
                        React.createElement(Grid.Column, null,
                            React.createElement("h5", null, "RNA-FISH (manual) reports"),
                            _this.getReportCategory(availableReports, "RNA_FISH"),
                            React.createElement("h5", null, "Automated Pro reports"),
                            _this.getReportCategory(availableReports, "RNA_CISH"),
                            React.createElement("h5", null, "2\u00BAIF (manual) reports"),
                            _this.getReportCategory(availableReports, "IHC2"),
                            React.createElement("h5", null, "GOLD IF reports"),
                            _this.getReportCategory(availableReports, "GOLD_IF")),
                        React.createElement(Grid.Column, null,
                            React.createElement("h5", null, "Configuration"),
                            _this.renderReportConfig(config, availableReports.prodStatuses)))));
        };
        _this.renderReportConfig = function (config, allProdStatuses) {
            var stackedField = React.createElement(Form.Field, null,
                React.createElement("label", null, "Stacked"),
                React.createElement(Checkbox, { checked: _this.state.stacked, onChange: _this.onStackedChange }));
            var defaultAggregateOptions = [
                { text: '1', value: 1 },
                { text: '7', value: 7 },
                { text: '14', value: 14 },
                { text: '28', value: 28 },
                { text: '91', value: 91 },
                { text: '365', value: 365 },
            ];
            var displayPerTypeUi = function () {
                var trailingWindowDays;
                if (config instanceof OrdersReportConfig) {
                    trailingWindowDays = config.aggregateDays;
                }
                else {
                    trailingWindowDays = config.trailingSumDays;
                }
                var aggregateOptions = defaultAggregateOptions;
                if (aggregateOptions.find(function (a) { return a.value === trailingWindowDays; }) === undefined) {
                    aggregateOptions.push({
                        text: trailingWindowDays.toString(),
                        value: trailingWindowDays
                    });
                }
                var buildTrailingWindowDropdown = function (onWindowSizeChange) {
                    return React.createElement(Dropdown, { allowAdditions: true, fluid: true, onChange: onWindowSizeChange, options: aggregateOptions, search: true, selection: true, style: { width: '5rem' }, value: trailingWindowDays });
                };
                var onDatasetLimitChange = function (_, data) {
                    var value = data.value;
                    // we shouldn't ever actually encounter an unset reportConfig since this UI isn't even visible if
                    // that hasn't loaded yet
                    if (value.trim() === '') {
                        _this.setState(function (oldState) { return ({
                            reportConfig: oldState.reportConfig.withDatasetLimit(undefined)
                        }); });
                        return;
                    }
                    var num = parseInt(value, 10);
                    if (isNaN(num) || num < 1) {
                        return;
                    }
                    _this.setState(function (oldState) { return ({
                        reportConfig: oldState.reportConfig.withDatasetLimit(num)
                    }); });
                };
                var topNInput = React.createElement(Form.Field, null,
                    React.createElement("label", null,
                        "Limit to top ",
                        React.createElement("em", null, "n"),
                        " ",
                        React.createElement(Help, null,
                            "If set, show the top ",
                            React.createElement("em", null, "n"),
                            " datasets based on the final displayed value and calculate an \"Other\" dataset that combines the remaining data sets")),
                    React.createElement(Input
                    // undocumented onBlur?
                    // only hit the server on blur rather than on every keystroke
                    , { 
                        // undocumented onBlur?
                        // only hit the server on blur rather than on every keystroke
                        onBlur: _this.loadReports, onChange: onDatasetLimitChange, style: { width: '5rem' }, value: config.datasetLimit ? config.datasetLimit.toString() : '' }));
                if (config instanceof OrdersReportConfig) {
                    var onWindowSizeChange = function (_, data) {
                        var value = data.value;
                        var setSumDays = function (s) {
                            _this.setState({
                                reportConfig: config.withAggregateDays(s)
                            }, _this.loadReports);
                        };
                        parsePositiveNumberAndInvoke(value, setSumDays);
                    };
                    var onModeChangeCallback = function (toMode) {
                        return function (_, data) {
                            if (!data.checked) {
                                return;
                            }
                            _this.setState({
                                reportConfig: config.withAggregateMode(toMode)
                            }, _this.loadReports);
                        };
                    };
                    return React.createElement(React.Fragment, null,
                        React.createElement(Form.Field, null,
                            React.createElement("label", null, "Trailing window (days)"),
                            buildTrailingWindowDropdown(onWindowSizeChange)),
                        React.createElement(Form.Field, null,
                            React.createElement("label", null, "Window operation"),
                            React.createElement("div", null,
                                React.createElement(Checkbox, { checked: config.aggregateMode === AggregateMode.Sum, label: 'Sum over days', onChange: onModeChangeCallback(AggregateMode.Sum), radio: true })),
                            React.createElement("div", null,
                                React.createElement(Checkbox, { checked: config.aggregateMode === AggregateMode.Avg, label: 'Average over orders', onChange: onModeChangeCallback(AggregateMode.Avg), radio: true }))),
                        stackedField,
                        topNInput,
                        React.createElement(Form.Field, null,
                            React.createElement("label", null, "Prod statuses"),
                            allProdStatuses.map(function (s, index) {
                                var onChange = function (_, data) {
                                    _this.setState(function (oldState) {
                                        if (!(oldState.reportConfig instanceof OrdersReportConfig)) {
                                            throw new Error("Unexpected config type: " + oldState.reportConfig);
                                        }
                                        var included = new Set(oldState.reportConfig.prodStatuses);
                                        if (data.checked) {
                                            included.add(s);
                                        }
                                        else {
                                            included.delete(s);
                                        }
                                        return {
                                            reportConfig: oldState.reportConfig.withStatuses(included)
                                        };
                                    }, _this.loadReports);
                                };
                                return React.createElement("div", { key: index },
                                    React.createElement(Checkbox, { checked: config.prodStatuses.has(s), label: s, onChange: onChange }));
                            })));
                }
                else {
                    var onWindowSizeChange = function (_, data) {
                        var value = data.value;
                        var setSumDays = function (s) {
                            _this.setState({
                                reportConfig: config.withTrailingSumDays(s)
                            }, _this.loadReports);
                        };
                        parsePositiveNumberAndInvoke(value, setSumDays);
                    };
                    return React.createElement(React.Fragment, null,
                        React.createElement(Form.Field, null,
                            React.createElement("label", null, "Trailing sum (days)"),
                            buildTrailingWindowDropdown(onWindowSizeChange)),
                        stackedField,
                        topNInput);
                }
            };
            return React.createElement(Form, null, displayPerTypeUi());
        };
        _this.getReportCategory = function (availableReports, category) {
            console.log(availableReports.reports);
            return availableReports.reports.filter(function (rc) { return rc.reportCategory === category; }).map(function (r, index) {
                var onChange = function (_, data) {
                    if (!data.checked) {
                        return;
                    }
                    _this.setState(function (oldState) {
                        // if config types are the same, just carry it over
                        var newConfig;
                        if (oldState.selectedReport
                            && oldState.selectedReport.configType === r.configType
                            && oldState.reportConfig) {
                            newConfig = oldState.reportConfig;
                        }
                        else {
                            newConfig = _this.defaultConfig(r.configType, availableReports);
                        }
                        return {
                            selectedReport: r,
                            reportConfig: newConfig
                        };
                    }, _this.loadReports);
                };
                return React.createElement("div", { key: index },
                    React.createElement(Checkbox, { checked: _this.state.selectedReport && _this.state.selectedReport.reportType === r.reportType, label: r.label, onChange: onChange, radio: true }));
            });
        };
        _this.renderChart = function (response) {
            // in case there are negative values, calculate the minimum value
            var minValue = response.reports.map(function (r) { return r.data.reduce(function (accum, n) { return Math.min(accum, n); }); })
                .reduce(function (accum, n) { return Math.min(accum, n); }, 0);
            var yAxisMin = Math.min(minValue, 0);
            var axes = [{
                    stacked: _this.state.stacked,
                    position: 'left',
                    ticks: {
                        min: yAxisMin
                    }
                }];
            return React.createElement(Line, { data: {
                    labels: response.labels,
                    datasets: response.reports.map(function (r, index) {
                        var color = COLORS[index % COLORS.length];
                        return ({
                            backgroundColor: _this.state.stacked ? color : 'rgba(0,0,0,0.0)',
                            borderColor: color,
                            label: r.id,
                            data: r.data,
                            cubicInterpolationMode: 'monotone',
                            lineTension: 0,
                        });
                    })
                }, options: {
                    animation: {
                        duration: 0
                    },
                    scales: {
                        yAxes: axes
                    }
                } });
        };
        _this.onIntervalChange = function (interval) {
            _this.setState({ interval: interval }, _this.loadReports);
        };
        _this.onStackedChange = function (_, data) {
            var stacked = data.checked;
            if (stacked === undefined) {
                throw new Error("Undefined 'stacked'?");
            }
            _this.setState({
                stacked: stacked
            });
        };
        _this.buildReportRequestJson = function (interval, selectedReport, config, format) {
            var configJson = {
                _type: config.type,
            };
            if (config instanceof OrdersReportConfig) {
                configJson.prodStatuses = Array.from(config.prodStatuses);
                configJson.aggregateDays = config.aggregateDays;
                configJson.aggregateMode = config.aggregateMode;
            }
            else {
                configJson.trailingSumDays = config.trailingSumDays;
            }
            if (config.datasetLimit) {
                configJson.datasetLimit = config.datasetLimit;
            }
            var reportJson = {
                reportType: selectedReport.reportType,
                config: configJson
            };
            return JSON.stringify({
                createdNotBefore: interval.start.toFormat(dateOnlyFormat),
                createdNotAfter: interval.end.toFormat(dateOnlyFormat),
                format: format,
                // backend supports multiple reports, but building a UI that supports multiple reports
                // each with their own config is more than we want to tackle right now
                reports: [
                    reportJson
                ]
            });
        };
        _this.downloadCallback = function (interval, selectedReport, config) {
            return function () {
                var json = _this.buildReportRequestJson(interval, selectedReport, config, 'CSV');
                postJsonWithAuthn('/admin/reports', json)
                    .then(function (resp) {
                    if (resp.ok) {
                        return downloadDataFromResponse(resp);
                    }
                    else {
                        return Promise.resolve(undefined);
                    }
                })
                    .then(function (dl) {
                    if (dl) {
                        download(dl.blob, dl.filename, dl.contentType);
                    }
                    else {
                        _this.setState({
                            error: true
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't download report: " + rej);
                });
            };
        };
        _this.loadReports = function () {
            var interval = _this.state.interval;
            var selectedReport = _this.state.selectedReport;
            var reportConfig = _this.state.reportConfig;
            if (interval && selectedReport && reportConfig) {
                _this.setState({ loading: true }, function () {
                    var json = _this.buildReportRequestJson(interval, selectedReport, reportConfig, 'JSON');
                    postJsonWithAuthn("/admin/reports", json)
                        .then(function (resp) {
                        if (resp.ok) {
                            return resp.json();
                        }
                        else {
                            return undefined;
                        }
                    })
                        .then(function (resp) {
                        if (resp === undefined) {
                            _this.setState({
                                loading: false,
                                error: true
                            });
                        }
                        else {
                            _this.setState({
                                error: false,
                                loading: false,
                                response: resp
                            });
                        }
                    })
                        .catch(function (rej) {
                        console.error("Couldn't load report: " + rej);
                    });
                });
            }
        };
        _this.loadAvailableReports = function () {
            _this.setState({ availableReportsLoading: true }, function () {
                getWithAuthn("/admin/available-reports")
                    .then(function (resp) {
                    if (resp.ok) {
                        return resp.json();
                    }
                    else {
                        return undefined;
                    }
                })
                    .then(function (resp) {
                    if (resp === undefined) {
                        _this.setState({
                            availableReportsLoading: false,
                            error: true
                        });
                    }
                    else {
                        var defaultReport = resp.reports.find(function (r) { return r.reportType === resp.defaultReportType; });
                        _this.setState({
                            error: false,
                            availableReportsLoading: false,
                            availableReportsResponse: resp,
                            selectedReport: defaultReport,
                            reportConfig: _this.defaultConfig(defaultReport.configType, resp)
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't load report: " + rej);
                });
            });
        };
        _this.defaultConfig = function (configType, availableReports) {
            switch (configType) {
                case ReportConfigType.Orders:
                    return new OrdersReportConfig(new Set(availableReports.defaultProdStatuses), 1, AggregateMode.Sum);
                case ReportConfigType.TrailingSumDays:
                    return new TrailingSumDaysConfig(1);
                default:
                    throw new Error("Unexpected config type: " + configType);
            }
        };
        _this.state = {
            loading: false,
            availableReportsLoading: false,
            error: false,
            stacked: true
        };
        return _this;
    }
    ReportsPage.prototype.render = function () {
        // sanity check on config invariant
        if (this.state.selectedReport
            && this.state.reportConfig
            && (this.state.selectedReport.configType !== this.state.reportConfig.type)) {
            throw new Error("Selected report " + this.state.selectedReport.reportType + " should not have config type " + this.state.reportConfig.type);
        }
        return React.createElement(React.Fragment, null,
            React.createElement(Header, null, "Reports"),
            React.createElement(Dimmer.Dimmable, { id: "non-header-portion" },
                React.createElement(Dimmer, { active: this.state.availableReportsLoading, inverted: true },
                    React.createElement(Loader, null)),
                this.state.availableReportsResponse && this.state.reportConfig &&
                    React.createElement(Menu, null,
                        React.createElement(Menu.Item, null,
                            React.createElement(Button, { disabled: this.state.interval === undefined, icon: 'refresh', onClick: this.loadReports })),
                        React.createElement(Menu.Item, null,
                            React.createElement(DateRangePicker
                            // Setting the default date range changes the interval, which calls loadReports() the first
                            // time
                            , { 
                                // Setting the default date range changes the interval, which calls loadReports() the first
                                // time
                                dayRangeOptions: [1, 7, 14, 28, 91, 365], defaultDayRange: 28, interval: this.state.interval, onIntervalChange: this.onIntervalChange, includePresets: true })),
                        React.createElement(Menu.Item, null,
                            React.createElement(Popup, { on: 'click', trigger: React.createElement(Button, { icon: 'chart bar', label: 'Reports' }), flowing: true, wide: 'very' }, this.renderReportTypePicker(this.state.reportConfig, this.state.availableReportsResponse))),
                        this.state.interval && this.state.selectedReport && this.state.reportConfig &&
                            React.createElement(Menu.Item, null,
                                React.createElement(Button, { icon: 'download', label: 'CSV', labelPosition: 'left', onClick: this.downloadCallback(this.state.interval, this.state.selectedReport, this.state.reportConfig) }))),
                this.state.error && React.createElement(Message, { negative: true }, "Reports could not be loaded."),
                React.createElement(Dimmer.Dimmable, null,
                    React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                        React.createElement(Loader, null)),
                    this.state.response && this.state.selectedReport && this.renderChart(this.state.response),
                    !this.state.response && React.createElement("div", null,
                        "Pick a report above ",
                        React.createElement(Icon, { name: 'hand point up outline' })))));
    };
    ReportsPage.prototype.componentDidMount = function () {
        this.loadAvailableReports();
    };
    return ReportsPage;
}(React.PureComponent));
export default ReportsPage;
/**
 * If parsing succeeds, the callback will be invoked with the result.
 * If parsing returns NaN or is 0 or negative, returns without invoking the callback.
 * If the input is not a number or string, throws.
 *
 * @param value a user-entered thing from a dropdown
 * @param callback will be invoked with the parsed number if parsing succeeds
 */
var parsePositiveNumberAndInvoke = function (value, callback) {
    if (typeof (value) === 'number') {
        callback(value);
    }
    else if (typeof (value) === 'string') {
        var num = parseInt(value, 10);
        if (isNaN(num) || num < 1) {
            return;
        }
        callback(num);
    }
    else {
        throw new Error("Unexpected avg: " + value);
    }
};
var ReportConfigType;
(function (ReportConfigType) {
    ReportConfigType["Orders"] = "ORDERS";
    ReportConfigType["TrailingSumDays"] = "TRAILING_SUM_DAYS";
})(ReportConfigType || (ReportConfigType = {}));
var OrdersReportConfig = /** @class */ (function () {
    function OrdersReportConfig(prodStatuses, aggregateDays, aggregateMode, datasetLimit) {
        var _this = this;
        this.type = ReportConfigType.Orders;
        this.withStatuses = function (statuses) {
            return new OrdersReportConfig(statuses, _this.aggregateDays, _this.aggregateMode, _this.datasetLimit);
        };
        this.withAggregateDays = function (aggregateDays) {
            return new OrdersReportConfig(_this.prodStatuses, aggregateDays, _this.aggregateMode, _this.datasetLimit);
        };
        this.withAggregateMode = function (aggregateMode) {
            return new OrdersReportConfig(_this.prodStatuses, _this.aggregateDays, aggregateMode, _this.datasetLimit);
        };
        this.withDatasetLimit = function (datasetLimit) {
            return new OrdersReportConfig(_this.prodStatuses, _this.aggregateDays, _this.aggregateMode, datasetLimit);
        };
        this.prodStatuses = prodStatuses;
        this.aggregateDays = aggregateDays;
        this.aggregateMode = aggregateMode;
        this.datasetLimit = datasetLimit;
    }
    return OrdersReportConfig;
}());
var AggregateMode;
(function (AggregateMode) {
    AggregateMode["Sum"] = "SUM";
    AggregateMode["Avg"] = "AVG_ORDERS";
})(AggregateMode || (AggregateMode = {}));
var TrailingSumDaysConfig = /** @class */ (function () {
    function TrailingSumDaysConfig(trailingSumDays, datasetLimit) {
        var _this = this;
        this.type = ReportConfigType.TrailingSumDays;
        this.withTrailingSumDays = function (trailingSumDays) {
            return new TrailingSumDaysConfig(trailingSumDays, _this.datasetLimit);
        };
        this.withDatasetLimit = function (datasetLimit) {
            return new TrailingSumDaysConfig(_this.trailingSumDays, datasetLimit);
        };
        this.trailingSumDays = trailingSumDays;
        this.datasetLimit = datasetLimit;
    }
    return TrailingSumDaysConfig;
}());
// From https://eleanormaclure.files.wordpress.com/2011/03/colour-coding.pdf
var COLORS = [
    '#f2cc4f',
    '#592c8f',
    '#ec6522',
    '#94d6e9',
    '#c8272d',
    '#c0bf83',
    '#768181',
    '#5caa46',
    '#d887ba',
    '#5696c7',
    '#e98262',
    '#2a3199',
    '#ec9f36',
    '#862991',
    '#ece665',
    '#831c16',
    '#8eb03e',
    '#6e361c',
    '#e4331b',
    '#2a341a'
].map(function (hex) {
    var justHex = hex.substr(1, 6);
    var red = parseInt(justHex.substr(0, 2), 16);
    var green = parseInt(justHex.substr(2, 2), 16);
    var blue = parseInt(justHex.substr(4, 2), 16);
    return "rgba(" + red + ", " + green + ", " + blue + ", 1.0)";
});
/**
 * Package up response data so that it can be presented to the user as a file download.
 * @param resp a successful response with content-type and content-disposition headers
 */
var downloadDataFromResponse = function (resp) {
    // rely on what the server generated
    var contentType = resp.headers.get("content-type");
    var contDisp = resp.headers.get("content-disposition");
    var parsed = contentDisposition.parse(contDisp);
    var filename = parsed.parameters.filename;
    return resp.blob().then(function (blob) {
        return {
            blob: blob,
            contentType: contentType,
            filename: filename
        };
    });
};
//# sourceMappingURL=ReportsPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ReportsPage.js
// module id = 1272
// module chunks = 0